import { render, staticRenderFns } from "./ADULT_COMPLETED.vue?vue&type=template&id=1fdc9635&"
import script from "./ADULT_COMPLETED.vue?vue&type=script&lang=js&"
export * from "./ADULT_COMPLETED.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports